import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import { TjDatePicker } from 'components/TjDatePicker/TjDatePicker';
import { DATE_FORMATS } from 'components/TjDatePicker/constants/dateFormats';
import { getPickerOptions } from '../functions/getMonthPickerOptions';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';
import QuestionOptionsContainer from './QuestionOptionsContainer';

export const MonthPicker = ({
  question, isFullWidth, onChange, value,
}) => {
  const { id, title, subtitle } = question;
  const { form } = useSelector((state) => state.questionnaire);

  const initialDate = value ? moment({
    year: value?.year?.[0]?.value,
    month: value?.month?.[0]?.value,
  }) : null;
  const selectedDate = useRef(initialDate);
  const { startDate, endDate, focusedDate } = getPickerOptions(question.dateType, form);

  const handleDateChange = (date) => {
    selectedDate.current = date;
  };

  const handleDateClose = () => {
    const date = selectedDate.current;
    if (!date) {
      return;
    }

    onChange({
      year: [{ label: date.format(DATE_FORMATS.YEAR_FORMAT), value: date.year() }],
      month: [{ label: date.format(DATE_FORMATS.MONTH_FORMAT), value: date.month() }],
    });
  };

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}
      <QuestionOptionsContainer isFullWidth={isFullWidth}>
        <TjDatePicker
          initialValue={initialDate}
          minDate={startDate}
          maxDate={endDate}
          onChange={handleDateChange}
          onClose={handleDateClose}
          initialFocusedDate={focusedDate}
        />
      </QuestionOptionsContainer>
    </Grid>
  );
};

MonthPicker.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  isFullWidth: PropTypes.bool,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
